import { InfoSIM } from '../models/ConfigureLine';
import { getSIMSInfos } from '../services/ConfigureLineService';

const useSimsInfos = () => {
    const simsInfosRequest = async (setDataSims: React.Dispatch<React.SetStateAction<InfoSIM[]>>) => {
        try {
            const response = await getSIMSInfos();

            setDataSims(response);
        } catch (error) {
            console.error(error);
        }
    };

    return { simsInfosRequest };
};

export default useSimsInfos;
